"use client";

import type { ReactNode } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { VariantSectionError } from "./variant-section-error";

/**
 * Client-only error boundary so we can log failures (Server Components cannot pass `onError` functions).
 */
export function VariantSectionErrorBoundary({ children }: { children: ReactNode }) {
	return (
		<ErrorBoundary
			FallbackComponent={VariantSectionError}
			onError={(error, info) => {
				const message = error instanceof Error ? error.message : String(error);
				console.error("[PDP VariantSection]", message, error, info.componentStack);
			}}
		>
			{children}
		</ErrorBoundary>
	);
}
